export default class Modal {
  constructor(el) {
    this.el = el
    this.opened = false
    this.triggers = this.el.querySelectorAll('[data-modal-trigger]')
    if(!this.triggers || !this.triggers.length) return
    this.stage = this.el.querySelector('[data-modal-stage')
    this.targets = this.stage.querySelectorAll('[data-modal-target]')
    if(!this.targets || !this.targets.length) {
      return
    } else {
      this.closes = this.el.querySelectorAll('[data-modal-close]')
      this.init()
    }
    this.active = 'is-active'
    this.openModal = 'is-open'
    this.ytpFlg = false
    this.activeYtp = null
  }

  init() {
    this.bindEvents()
    this.dlYtPlayer()
  }

  bindEvents() {
    window.onYouTubeIframeAPIReady = () => {
      this.ytpFlg = true
    }

    if(this.triggers || this.triggers.length) {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', e => {
          e.preventDefault()

          const id = trigger.getAttribute('data-modal-trigger')

          if(this.ytpFlg) this.open(id)
        })
      })
    }

    if(this.closes || this.closes.length) {
      this.closes.forEach(close => {
        close.addEventListener('click', e => {
          e.preventDefault()

          this.close()
        })
      })
    }

    document.addEventListener('keydown', e => {
      if(this.opened) {
        if(27 === e.keyCode) {
          this.close()
        }
      }
    })
  }

  dlYtPlayer() {
    let tag = document.createElement('script')
    tag.src = "https://www.youtube.com/iframe_api"
    let firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  open(id) {
    // Modal がまだ開かれていなければ初動処理を行う
    if(!this.opened) {
      document.body.classList.add(this.openModal)
      this.stage.classList.add(this.active)

      this.targets.forEach(target => {
        if(id === target.getAttribute('data-yt-id')) {
          this.genYt(target, target.getAttribute('data-yt-id'))
          target.classList.add(this.active)
        }
      })

      this.opened = true
    }
  }

  close() {
    this.targets.forEach(target => {
      target.classList.remove(this.active)
      if(target.getAttribute('data-yt-id') && target.classList.contains(this.active)) this.removeCnt(target)
    })

    document.body.classList.remove(this.openModal)
    this.stage.classList.remove(this.active)

    this.opened = false
    this.activeYtp.stopVideo()
    this.activeYtp.destroy()
  }

  genYt(target, id) {
    const inner = target.children[0].children[0]
    this.activeYtp = new YT.Player(inner, {
      videoId: id,
      events: {
        'onReady': e => {
          console.log(e)
          e.target.playVideo()
        }
      }
    })

    // inner.innerHTML = ''
    // inner.appendChild(iframe)

  }

  removeCnt(target) {
    const inner = target.children[0]

    setTimeout(() => {
      inner.innerHTML = '&nbsp;'
    }, 500)
  }
}
